import {IBackendCaller} from "./backendCaller";
import {
  VillageCalendarConfig,
  VillageCalendarConfigPayload
} from "../shared/interfaces/villageCalendarConfig";

const villageCalendarsUrl = "/api/villagecalendars";

/**
 * Service for interacting with the admin village calendars BFF endpoint.
 */
export interface IVillageCalendarService {
  getVillageCalendars: (
    abortController?: AbortController,
    villageId?: string
  ) => Promise<VillageCalendarConfig[]>;
  createVillageCalendar: (
    payload: VillageCalendarConfigPayload
  ) => Promise<VillageCalendarConfig>;
  updateVillageCalendar: (
    id: string,
    payload: VillageCalendarConfigPayload
  ) => Promise<VillageCalendarConfig>;
  deleteVillageCalendar: (id: string) => Promise<void>;
}

export class VillageCalendarService implements IVillageCalendarService {
  private readonly backendCaller: IBackendCaller;

  constructor(backendCaller: IBackendCaller) {
    this.backendCaller = backendCaller;
  }

  getVillageCalendars = async (
    abortController?: AbortController,
    villageId?: string
  ) => {
    const url = villageId
      ? `${villageCalendarsUrl}?villageId=${encodeURIComponent(villageId)}`
      : villageCalendarsUrl;
    return await this.backendCaller.callApi(
      "GET",
      url,
      null,
      null,
      false,
      abortController
    );
  };

  createVillageCalendar = async (payload: VillageCalendarConfigPayload) => {
    return await this.backendCaller.callApi(
      "POST",
      villageCalendarsUrl,
      JSON.stringify(payload)
    );
  };

  updateVillageCalendar = async (
    id: string,
    payload: VillageCalendarConfigPayload
  ) => {
    return await this.backendCaller.callApi(
      "PUT",
      `${villageCalendarsUrl}/${id}`,
      JSON.stringify(payload)
    );
  };

  deleteVillageCalendar = async (id: string) => {
    return await this.backendCaller.callApi(
      "DELETE",
      `${villageCalendarsUrl}/${id}`
    );
  };
}
